import { CustomColumnType, getCustomColumnTypes } from "./grid-column-types";
import { pivotRowsToMetrics } from "./insGrid-cashflow-pivot";
import { createLink } from "./renderers/datapointLinkCellRenderer";
import { history } from "store";
const noQuickFilter = () => "";
export const FUND_LEVEL_PREFIX = "_fundLevel_";
export const ACTUAL_HEADER = "Actual";
export const PROJECTED_HEADER = "Projected";
export const firstValueAggFunc = (params) => {
    const [child] = params.rowNode.allLeafChildren || [];
    return child?.data?.[`${FUND_LEVEL_PREFIX}${params.colDef.field}`] ?? null;
};
export const hideOnLeafRows = (params) => (params.node?.group ? params.value : "");
export const injectAggFunc = (columns, fundLevelFields) => columns.map((col) => {
    if (col.children) {
        return { ...col, children: injectAggFunc(col.children, fundLevelFields) };
    }
    if (fundLevelFields.includes(col.field || "")) {
        return { ...col, aggFunc: firstValueAggFunc, getQuickFilterText: noQuickFilter, valueFormatter: hideOnLeafRows };
    }
    return col;
});
const cashflowCellRendererSelector = (params) => {
    const rowType = params?.data?.type;
    if (!rowType || rowType === CustomColumnType.InsMoneyColumn) {
        return undefined;
    }
    const cellRenderer = getCustomColumnTypes("")[rowType]?.cellRenderer;
    return cellRenderer ? { component: cellRenderer, params } : undefined;
};
export const buildYearColumns = (yearKeys, sectionId, widgetId) => yearKeys.map((year) => ({
    aggFunc: firstValueAggFunc,
    cellRendererParams: { sectionId, widgetId },
    cellRendererSelector: cashflowCellRendererSelector,
    field: year,
    getQuickFilterText: noQuickFilter,
    headerName: year,
    sortable: false,
    suppressHeaderMenuButton: true,
    type: "insMoneyColumn",
    width: 100
}));
const fundNameQuickFilter = (params) => params.data?.FundNameGroup ?? "";
const fundNameGroupFormatter = (params) => {
    if (params.node?.group) {
        const fundName = params.node.allLeafChildren?.[0]?.data?.FundNameGroup;
        if (fundName) {
            return fundName;
        }
    }
    return params.value;
};
const applyDisplayFieldFormatter = (columns, displayField) => columns.map((col) => (col.field === displayField && col.rowGroup
    ? { ...col, getQuickFilterText: fundNameQuickFilter, valueFormatter: fundNameGroupFormatter }
    : col));
const buildYearColumnGroups = (actualYearKeys, projectedYearKeys, sectionId, widgetId, projectedHeader) => {
    const groups = [];
    if (actualYearKeys.length > 0) {
        groups.push({ children: buildYearColumns(actualYearKeys, sectionId, widgetId), headerName: ACTUAL_HEADER });
    }
    if (projectedYearKeys.length > 0) {
        groups.push({ children: buildYearColumns(projectedYearKeys, sectionId, widgetId), headerName: projectedHeader ?? PROJECTED_HEADER });
    }
    return groups;
};
export const groupLinkStyle = (params) => (params.node?.group ? { color: "var(--tertiary__color)", cursor: "pointer" } : {});
const createFundLinkMapping = (leafData) => {
    const mapping = {
        field: "FundName",
        id: "FundId",
        params: [],
        path: "/fund/"
    };
    /*
     * https://1a4d.visualstudio.com/Alts/_workitems/edit/3499175
     * Generic Investors have a fake investor ID that we don't want to pass to the link
     * The backend returns "true" or "false" as strings, so we need to check for both
     */
    const isGenericInvestor = typeof leafData.IsGenericInvestor === "string" ? leafData.IsGenericInvestor === "true" : Boolean(leafData.IsGenericInvestor);
    if (!isGenericInvestor) {
        mapping.params.push({ field: "InvestorId", name: "investorId" });
    }
    return mapping;
};
export const handleGroupCellClicked = (event) => {
    if (!event.node?.group) {
        return;
    }
    const leafData = event.node.allLeafChildren?.[0]?.data;
    if (!leafData?.FundId) {
        return;
    }
    const mapping = createFundLinkMapping(leafData);
    const { link } = createLink(mapping, leafData);
    if (!link) {
        return;
    }
    if (event.event && (event.event.metaKey || event.event.ctrlKey)) {
        window.open(link, "_blank");
    }
    else {
        history.push(link);
    }
};
export const applyMetricsPivot = (adapterRows, columns, metricsPivot, sectionId, widgetId) => {
    const pivotResult = pivotRowsToMetrics(adapterRows, metricsPivot);
    const yearColumnGroups = buildYearColumnGroups(pivotResult.actualYearKeys, pivotResult.projectedYearKeys, sectionId, widgetId, metricsPivot.projectedHeader);
    const pivotColumns = applyDisplayFieldFormatter(columns, metricsPivot.displayField);
    return {
        columns: injectAggFunc([...pivotColumns, ...yearColumnGroups], metricsPivot.fundLevelFields ?? []),
        rows: pivotResult.rows
    };
};
